export enum EUrokovaSazba {
    F = 'F',
    V = 'V',
    Z = 'Z',
    N = 'N',
    K = 'K',
    J = 'J'
}
